import React from 'react';
import { Header, Table } from 'semantic-ui-react';

// Workspaces
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';

// Global Components
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
// @ts-ignore
import ErrorGate from 'components/ErrorGate';
// @ts-ignore
import TableCountDropdown from 'components/TableCountDropdown';

// Child Components
// @ts-ignore
import CreateSeasonalEventButton from '../../../../components/CreateSeasonalEventButton';
// @ts-ignore
import EventsTablePagination from './components/EventsTablePagination';
// @ts-ignore
import EventTableHead from './components/EventTableHead';
import EventTableRows from './components/EventTableRows';

// Styles
import './styles.scss';

const EventsTable = (): React.ReactElement => (
    <ErrorBoundary
        namespace="EventsTable"
        FallbackComponent={<ErrorBoundaryAlert />}
    >
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: 14
            }}
        >
            <div
                // HACK inline styles
                style={{
                    marginTop: 10
                }}
            >
                <Header as="h4">
                    <span
                        // HACK inline styles
                        style={{
                            marginRight: 13
                        }}
                    >
                        {'Harvest Planner '}
                    </span>
                    <span
                        // HACK inline styles
                        style={{
                            color: 'rgb(102, 102, 102)',
                            fontSize: '12px',
                            fontWeight: 'normal',
                            display: 'inline-block',
                            verticalAlign: 'top',
                            marginTop: 1
                        }}
                    >
                        (Drag and drop items onto calendar)
                    </span>
                </Header>
            </div>
            <div style={{ marginLeft: 'auto' }}>
                <CreateSeasonalEventButton />
            </div>
        </div>
        <div className="events-table-table-container">
            <ErrorGate namespace="UNSCHEDULED_EVENTS_LOAD">
                <Table
                    selectable
                    sortable
                    striped
                    fixed
                    singleLine
                    unstackable
                    size="small"
                >
                    <EventTableHead />
                    <Table.Body>
                        <EventTableRows />
                    </Table.Body>
                </Table>
            </ErrorGate>
        </div>
        <div style={{ display: 'flex' }}>
            <div style={{ marginLeft: 'auto' }}>
                <TableCountDropdown />
                <EventsTablePagination />
            </div>
        </div>
    </ErrorBoundary>
);

export default EventsTable;
